// extracted by mini-css-extract-plugin
export var subtitle = "_b2-2";
export var title = "_b2-0";
export var titleNoWrap = "_b2-1";